import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import {
    JiraConnectorSettings,
    JiraTestTicketResponse,
} from '@client/app/feature-modules/shared/jira-connector/types/jira-connector.type';

@Injectable({
    providedIn: 'root',
})
export class JiraConnectorRepo {
    constructor (
        private apiService: ApiService,
    ) {
    }

    getSettings (): Promise<JiraConnectorSettings> {
        return this.apiService.get('jira/connector', undefined, undefined, contextTokens.NO_GLOBAL);
    }

    createSettings (settings: JiraConnectorSettings): Promise<JiraConnectorSettings> {
        return this.apiService.post('jira/connector', settings, contextTokens.NO_GLOBAL);
    }

    updateSettings (settings: Partial<JiraConnectorSettings>): Promise<JiraConnectorSettings> {
        return this.apiService.patch('jira/connector', settings, undefined, contextTokens.NO_GLOBAL);
    }

    deleteSettings (): Promise<void> {
        return this.apiService.delete('jira/connector', undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    testTicket (): Promise<JiraTestTicketResponse> {
        return this.apiService.post('jira/connector/test-issue', {}, contextTokens.NO_GLOBAL);
    }

    createIssue (payload: { issue_id: number, issue_type: string, title: string; description: string }): Promise<{ url: string }> {
        return this.apiService.post('jira/issues', payload);
    }
}
